export default "__VITE_ASSET__58945166__"